"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../../actions/types");
var _StudioLogger = require("@studio/logger/StudioLogger");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var logger = new _StudioLogger.StudioLogger('studio-uploadStatusUpdate-tracker');
var initialState = [];
/**
 * updates the status of file
 * and add the file only if it is in uploading state
 */
function uploadStatus() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  // this is dispatched while performing the actual upload
  if (action.type === _types.BROADCAST_SET_SOURCE_UPLOAD_STATUS) {
    var index = state.findIndex(function (source) {
      return source.sourceId === action.payload.sourceId;
    });
    if (index !== -1) {
      logger.info("Status of source file ".concat(action.payload.sourceId, " got updated to ").concat(action.payload.status), action.payload);
      return state.map(function (source) {
        if (source.sourceId === action.payload.sourceId) {
          source.status = action.payload.status;
        }
        return source;
      });
    } else {
      if (action.payload.status === 'UPLOADING') {
        logger.info("Source file ".concat(action.payload.sourceId, " got added"), action.payload);
        return [action.payload].concat(_toConsumableArray(state));
      }
    }
  }

  // Clears the state and logs the action with Datadog when the 'UploadStatusPane' modal is closed.
  // Checks if action type is SET_UPLOAD_STATUS_VISIBILITY with a false payload.
  if (action.type === _types.SET_UPLOAD_STATUS_VISIBILITY && action.payload === false) {
    if (state.length > 0) {
      logger.info("State uploadStatus got cleared", action.payload);
    }
    return initialState;
  }
  return state;
}
var _default = exports["default"] = uploadStatus;